import { Attributes, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class FileSpecLookup extends ModelBase {

    public staticFileSpecId: number = 0;

    @Rules.Required()
    @Rules.StringLength(100)
    public fileType: string = "";

    @Rules.Required()
    @Rules.StringLength(20)
    public enumFileExtension: string = "";

    @Rules.Required()
    @Rules.StringLength(20)
    public enumFileDelimiter: string = "";

    @Rules.Required()
    @Rules.StringLength(1000)
    public description: string = "";

    @Attributes.Date()
    @Rules.Required()
    public activeStartDate: Date | null = null;

    @Attributes.Date()
    public activeEndDate: Date | null = null;

    @Rules.Required()
    @Rules.StringLength(100)
    public rawDataTableName: string = "";

    @Rules.Required()
    @Rules.StringLength(100)
    public rawGenericTableName: string = "";

    @Rules.Required()
    @Rules.StringLength(100)
    public errorHoldingTableName: string = "";

    @Rules.Required()
    @Attributes.Integer()
    public columnCount: number = 0;

    public hasCheckConstraintInd: boolean = false;

    @Rules.Required()
    @Attributes.Integer()
    public startColumnHeaderRead: number = 0;

    public containHeaderInd: boolean = false;

    public isSingleFileInd: boolean = false;

    public isIgnoredInd: boolean = false;

    public isActiveInd: boolean = false;

    public latestFileSpecVersionID: number | null = null;

    public isCreatedFromPreviousVersionInd: boolean = false;
}